import { styled } from '@/stitches.config';
import { ReactComponent as Check } from '@assets/icons/check.svg';

export const StyledCheckIcon = styled(Check, {
  height: '$4',
  width: '$4',
});
